import React, { useContext } from 'react'

import { forEach, set } from 'lodash'
import { Col, Row } from 'react-bootstrap'
import styled from 'styled-components'

import Address from '../../../../1stlog-ui/src/components/Address'
import Badge from '../../../../1stlog-ui/src/components/Badge'
import BadgeGroup from '../../../../1stlog-ui/src/components/BadgeGroup'
import Icon from '../../../../1stlog-ui/src/components/Icon'
import ShipmentDetailsContext from '../Context'

export const Wrapper = styled.div`
  border-bottom: 1px solid rgba(34, 36, 38, 0.15); //  rgba(128, 128, 128, 0.61);
  background-color: #fafafa;
  border-top: 1px solid rgba(34, 36, 38, 0.15); // 1px solid rgba(128, 128, 128, 0.48);
`

const AddressBar = (props) => {
  const { coli, switcher, readOnly = false } = props

  const customerAdditionalData = {}
  const senderAdditionalData = {}
  const receiverAdditionalData = {}
  const neutralAdditionalData = {}

  forEach(coli?.additionalAddressInformation, ({ addressType, key, value }) => {
    switch (addressType) {
      case 'customer':
        set(customerAdditionalData, key, value)
        break
      case 'sender':
        set(senderAdditionalData, key, value)
        break
      case 'receiver':
        set(receiverAdditionalData, key, value)
        break
      case 'neutral':
        set(neutralAdditionalData, key, value)
        break
    }
  })

  const customer =
    props.customer ||
    (coli && {
      ...customerAdditionalData,
      id: coli.customerAddressId,
      highlightedId: coli.customerAddressOriginalId,
      name1: coli.customerName1,
      name2: coli.customerName2,
      name3: coli.customerName3,
      street: coli.customerStreet,
      streetNumber: coli.customerStreetNumber,
      streetNumberAddition: coli.customerStreetNumberAddition,
      zip: coli.customerZip,
      city: coli.customerCity,
      country: coli.customerCountry,
      ref1: coli.customerRef1,
      ref2: coli.customerRef2,
      ref3: coli.customerRef3,
      lonlat: [coli.customerLon, coli.customerLat],
    }) ||
    {}
  const sender =
    props.sender ||
    (coli && {
      ...senderAdditionalData,
      id: coli.senderAddressId,
      highlightedId: coli.senderAddressOriginalId,
      name1: coli.senderName1,
      name2: coli.senderName2,
      name3: coli.senderName3,
      street: coli.senderStreet,
      streetNumber: coli.senderStreetNumber,
      streetNumberAddition: coli.senderStreetNumberAddition,
      zip: coli.senderZip,
      city: coli.senderCity,
      country: coli.senderCountry,
      ref1: coli.senderRef1,
      ref2: coli.senderRef2,
      ref3: coli.senderRef3,
      lonlat: [coli.senderLon, coli.senderLat],
    }) ||
    {}
  const neutralSender =
    props.neutralSender ||
    (coli &&
      coli.neutralSenderName1 && {
        ...neutralAdditionalData,
        id: coli.neutralSenderAddressId,
        highlightedId: coli.neutralSenderAddressOriginalId,
        name1: coli.neutralSenderName1,
        name2: coli.neutralSenderName2,
        name3: coli.neutralSenderName3,
        street: coli.neutralSenderStreet,
        streetNumber: coli.neutralSenderStreetNumber,
        streetNumberAddition: coli.neutralSenderStreetNumberAddition,
        zip: coli.neutralSenderZip,
        city: coli.neutralSenderCity,
        country: coli.neutralSenderCountry,
        ref1: coli.neutralSenderRef1,
        ref2: coli.neutralSenderRef2,
        ref3: coli.neutralSenderRef3,
        lonlat: [coli.neutralSenderLon, coli.neutralSenderLat],
      })
  const receiver =
    props.receiver ||
    (coli && {
      ...receiverAdditionalData,
      id: coli.receiverAddressId,
      highlightedId: coli.receiverAddressOriginalId,
      name1: coli.receiverName1,
      name2: coli.receiverName2,
      name3: coli.receiverName3,
      street: coli.receiverStreet,
      streetNumber: coli.receiverStreetNumber,
      streetNumberAddition: coli.receiverStreetNumberAddition,
      zip: coli.receiverZip,
      city: coli.receiverCity,
      country: coli.receiverCountry,
      ref1: coli.receiverRef1,
      ref2: coli.receiverRef2,
      ref3: coli.receiverRef3,
      lonlat: [coli.receiverLon, coli.receiverLat],
    }) ||
    {}

  const { openAddress } = useContext(ShipmentDetailsContext)

  const stopLabel = (
    <BadgeGroup>
      <Badge variant="info">{i18n.t(`current_stop`, `Aktueller Stopp`)}</Badge>
    </BadgeGroup>
  )

  return (
    <Wrapper className="px-2 py-1">
      <Row>
        <Col
          md="4"
          sm="12"
        >
          <Address
            {...customer}
            title={i18n.t(`purchaser`, `Auftraggeber`)}
            allowEdit={!readOnly}
            onEdit={openAddress}
          />
        </Col>
        <Col md="4">
          <Address
            {...sender}
            address={sender}
            title={i18n.t(`sender`, `Absender`)}
            alternativeTitle={i18n.t(`neutral_sender`, `Neutralversender`)}
            labels={sender.isStopAddress && stopLabel}
            allowEdit={!readOnly}
            onEdit={openAddress}
            alternativeAddress={neutralSender}
          />
        </Col>
        <Col md="4">
          <Address
            address={receiver}
            title={i18n.t(`receiver`, `Empfänger`)}
            labels={receiver.isStopAddress && stopLabel}
            allowEdit={!readOnly}
            onEdit={openAddress}
          />
        </Col>
      </Row>
      {switcher && (
        <Row>
          <Col className="d-flex justify-content-end">
            <Badge color="secondary">
              {i18n.t(`customer_address`, `Kundenadresse`)}{' '}
              <Icon
                icon="far fa-exchange-alt"
                size={0.9}
              />
            </Badge>
          </Col>
        </Row>
      )}
    </Wrapper>
  )
}

export default AddressBar
